var _Defs, _Rect, _Rect2, _Rect3, _Rect4, _Rect5, _Rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, RadialGradient, Stop, Rect } from "react-native-svg";
function SvgRadial(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 200
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(RadialGradient, {
    id: "radial_svg__a",
    cx: "25%",
    cy: "90%"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: "0%",
    stopColor: "#00dbdb"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: "100%",
    stopColor: "#00dbdb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "radial_svg__b",
    cx: "75%",
    cy: "5%"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: "1%",
    stopColor: "#f08"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: "80%",
    stopColor: "#f08",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "radial_svg__c",
    cx: "0%",
    cy: "5%"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: "1%",
    stopColor: "#1d1c39"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: "50%",
    stopColor: "#1d1c39",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "radial_svg__d",
    cx: "95%",
    cy: "45%"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: "1%",
    stopColor: "#1d1c39"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: "105%",
    stopColor: "#1d1c39",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "radial_svg__e",
    cx: "98%",
    cy: "80%"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: "1%",
    stopColor: "#f08"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: "70%",
    stopColor: "#f08",
    stopOpacity: 0
  })))), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: "100%",
    height: "100%",
    fill: "#1D1C39"
  })), _Rect2 || (_Rect2 = /*#__PURE__*/React.createElement(Rect, {
    width: "100%",
    height: "100%",
    fill: "url(#radial_svg__a)",
    transform: "matrix(1 0 0 2 0 -240)"
  })), _Rect3 || (_Rect3 = /*#__PURE__*/React.createElement(Rect, {
    width: "100%",
    height: "100%",
    fill: "url(#radial_svg__b)",
    transform: "scale(1 2)"
  })), _Rect4 || (_Rect4 = /*#__PURE__*/React.createElement(Rect, {
    width: "100%",
    height: "100%",
    fill: "url(#radial_svg__c)",
    transform: "scale(1 2)"
  })), _Rect5 || (_Rect5 = /*#__PURE__*/React.createElement(Rect, {
    width: "100%",
    height: "100%",
    fill: "url(#radial_svg__d)",
    transform: "scale(1 2)"
  })), _Rect6 || (_Rect6 = /*#__PURE__*/React.createElement(Rect, {
    width: "100%",
    height: "100%",
    fill: "url(#radial_svg__e)",
    transform: "scale(1 2)"
  })));
}
export default SvgRadial;